import { Suspense, lazy, useEffect, useState } from 'react'

import loadingAnimation from '@/assets/animation/loading.json'
import { useGlobalLoading } from '@/store'

const Lottie = lazy(() => import('lottie-react'))

export const GlobalLoading = () => {
  const { globalLoading } = useGlobalLoading()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) return null

  return (
    <div className='fixed inset-0 z-[9999999999] bg-color-black-trans70' style={{ display: globalLoading ? 'block' : 'none' }} id='globalLoading'>
      <Suspense fallback={null}>
        <Lottie animationData={loadingAnimation} loop={true} className='mx-auto mt-[40vh] h-auto w-[10.4rem]' />
      </Suspense>
    </div>
  )
}
